/* FFC Cart Personalisation - one shared logo project across selected cart
   lines. Per-placement v2 charges DTF and embroidery per garment and keeps
   DST preparation as a one-off project fee. Pack inclusion is evaluated per
   cart line, so ordinary blanks never inherit a pack benefit. */
(function () {
  'use strict';

  var BLANK_PROPS = { 'Personalisation': 'No personalisation (blank)' };
  var SERVICE_DEFS = {
    dtf: { attr: 'data-fp-service-variant-dtf', type: 'dtf-placement', label: 'DTF print — placement', price: 250 },
    embroidery: { attr: 'data-fp-service-variant-embroidery', type: 'embroidery-placement', label: 'Embroidery — placement', price: 800 },
    dst: { attr: 'data-fp-service-variant-dst', type: 'dst-setup', label: 'DST file preparation', price: 2000 }
  };

  function root() { return document.querySelector('[data-fp-cart-pending]'); }
  function minQty(el) { return Number(el.getAttribute('data-fp-min-qty')) || 4; }
  function checkboxes(el) { return Array.prototype.slice.call(el.querySelectorAll('[data-fp-select-check]')); }
  function positiveInt(value) { return Math.max(0, parseInt(value, 10) || 0); }

  function serviceVariantId(el, key) {
    var def = SERVICE_DEFS[key];
    var value = def ? (el.getAttribute(def.attr) || '').trim() : '';
    return /^\d+$/.test(value) ? value : '';
  }

  function legacyServiceVariantId(el, tierKey) {
    var attr = tierKey === '4-15'
      ? 'data-fp-dtf-service-variant-4-15'
      : tierKey === '16-33'
        ? 'data-fp-dtf-service-variant-16-33'
        : 'data-fp-dtf-service-variant-34-plus';
    var value = (el.getAttribute(attr) || '').trim();
    return /^\d+$/.test(value) ? value : '';
  }

  function selectedQty(el) {
    return checkboxes(el).reduce(function (sum, cb) {
      return cb.checked ? sum + positiveInt(cb.getAttribute('data-qty')) : sum;
    }, 0);
  }

  function selectedRows(el) {
    return checkboxes(el).filter(function (cb) { return cb.checked; }).map(function (cb) {
      return {
        row: cb.closest('[data-fp-select-row]'),
        key: cb.getAttribute('data-line-key'),
        variantId: cb.getAttribute('data-variant-id'),
        qty: positiveInt(cb.getAttribute('data-qty')) || 1,
        colour: cb.getAttribute('data-colour'),
        dtfOk: cb.getAttribute('data-dtf-ok') === 'true',
        embOk: cb.getAttribute('data-emb-ok') === 'true',
        packIncluded: cb.getAttribute('data-pack-included') === 'true',
        packGroup: cb.getAttribute('data-pack-group') || '',
        packTitle: cb.getAttribute('data-pack-title') || ''
      };
    });
  }

  function showError(el, message) {
    var errorEl = el.querySelector('[data-fp-cart-error]');
    if (!errorEl) return;
    errorEl.hidden = false;
    errorEl.textContent = message;
  }

  // Shared-project compatibility, not product qualification. Never default a
  // missing permission to true. Per-garment method assignments are a separate
  // rollout; until then every row must support each selected method.
  function allowedMethodsForRows(rows) {
    return {
      dtf: rows.length > 0 && rows.every(function (row) { return row.dtfOk === true; }),
      embroidery: rows.length > 0 && rows.every(function (row) { return row.embOk === true; })
    };
  }

  function rowMethodsMatch(rows, properties) {
    var allowed = allowedMethodsForRows(rows);
    return (!positiveInt(properties._fp_dtf_placements) || allowed.dtf) &&
      (!positiveInt(properties._fp_embroidery_units) || allowed.embroidery);
  }

  function refresh() {
    var el = root();
    if (!el) return;
    el.hidden = el.children.length === 0;
    var boxes = checkboxes(el);
    var checked = boxes.filter(function (cb) { return cb.checked; });
    var qty = selectedQty(el);
    var min = minQty(el);
    var eligible = qty >= min;
    var countEl = el.querySelector('[data-fp-selected-count]');
    var actionBtn = el.querySelector('[data-fp-personalise-selected]');
    var selectAll = el.querySelector('[data-fp-select-all]');
    var minNote = el.querySelector('[data-fp-min-note]');
    var selectedUnit = el.querySelector('[data-fp-selected-unit]');
    if (countEl) countEl.textContent = String(qty);
    if (selectedUnit) selectedUnit.textContent = qty === 1 ? 'item' : 'items';
    if (actionBtn) actionBtn.disabled = !eligible;
    if (selectAll) {
      selectAll.checked = boxes.length > 0 && checked.length === boxes.length;
      selectAll.indeterminate = checked.length > 0 && checked.length < boxes.length;
    }
    if (minNote) {
      minNote.hidden = eligible;
      if (!eligible) {
        minNote.textContent = 'Personalisation is available from ' + min + ' garments.' +
          (qty > 0 ? ' You have selected ' + qty + ' — add ' + (min - qty) + ' more.' : '');
      }
    }
  }

  function newProjectId() {
    return 'p' + Date.now().toString(36) + Math.random().toString(36).slice(2, 7);
  }

  function responseJson(response, fallbackMessage) {
    if (response.ok) return response.json();
    return response.json().catch(function () { return {}; }).then(function (body) {
      throw new Error(body.description || fallbackMessage);
    });
  }

  function copyProps(source) {
    var out = {};
    Object.keys(source || {}).forEach(function (key) { out[key] = source[key]; });
    return out;
  }

  function safeContractText(value, maximum) {
    return String(value == null ? '' : value).replace(/[\u0000-\u001f\u007f]/g, ' ').trim().slice(0, maximum);
  }

  function structuredProperties(structured) {
    var contract = structured || {};
    var placements = Array.isArray(contract.placements) ? contract.placements.slice(0, 24) : [];
    var props = {
      '_fp_gateway': 'ordinary-v2',
      '_fp_contract_version': '2',
      '_fp_placement_count': String(placements.length),
      '_fp_artwork_rights': contract.rightsConfirmed === true ? 'yes' : 'no',
      '_fp_dst_status': safeContractText(contract.dstStatus, 16)
    };
    placements.forEach(function (placement, index) {
      var prefix = '_fp_p' + String(index + 1) + '_';
      props[prefix + 'id'] = safeContractText(placement.id, 64);
      props[prefix + 'method'] = safeContractText(placement.method, 16);
      props[prefix + 'emb_mode'] = safeContractText(placement.embMode, 16);
      props[prefix + 'text'] = safeContractText(placement.text, 120);
    });
    if (contract.artwork) {
      props._fp_artwork_name = safeContractText(contract.artwork.name, 150);
      props._fp_artwork_type = safeContractText(contract.artwork.type, 20);
      props._fp_artwork_size = safeContractText(contract.artwork.size, 30);
      props._fp_artwork_url = safeContractText(contract.artwork.url, 240);
      var quality = contract.artwork.quality;
      if (quality && quality.version === 'dtf-2026-09-17') {
        props._fp_aq_version = quality.version;
        props._fp_aq_hash = safeContractText(quality.artworkSha256, 64);
        props._fp_aq_original = safeContractText(quality.originalUrl, 240);
        props._fp_aq_processed = quality.processed ? 'yes' : 'no';
        if (quality.acknowledgement && quality.acknowledgement.accepted === true &&
            quality.acknowledgement.version === quality.version &&
            quality.acknowledgement.artworkSha256 === quality.artworkSha256) {
          props._fp_aq_accepted_at = safeContractText(quality.acknowledgement.acceptedAt, 40);
          props._fp_aq_presets = safeContractText((quality.acknowledgement.presets || []).join(','), 32);
        }
      }
    }
    var notes = safeContractText(contract.notes, 500);
    for (var i = 0; i < notes.length; i += 200) {
      props['_fp_notes_' + String(Math.floor(i / 200) + 1)] = notes.slice(i, i + 200);
    }
    return props;
  }

  function tierForQuantity(quantity) {
    if (quantity > 33) return { key: '34-plus', label: '34+ garments', amount: 3299 };
    if (quantity > 15) return { key: '16-33', label: '16-33 garments', amount: 2049 };
    return { key: '4-15', label: '4-15 garments', amount: 1599 };
  }

  function cartProjects(cart) {
    var projects = {};
    ((cart && cart.items) || []).forEach(function (item) {
      var props = item.properties || {};
      var id = props._fp_project;
      if (!id) return;
      if (!projects[id]) {
        projects[id] = { id: id, quantity: 0, model: 'legacy', services: [], expected: { dtf: 0, embroidery: 0, dst: 0 } };
      }
      var project = projects[id];
      if (props._fp_service) {
        project.services.push(item);
        return;
      }
      project.quantity += positiveInt(item.quantity);
      if (props._fp_gateway === 'ordinary-v2') {
        project.model = 'ordinary-v2';
      } else if (props._fp_pricing_model === 'per-placement-v2') {
        project.model = 'per-placement-v2';
        project.expected.dtf += positiveInt(item.quantity) * positiveInt(props._fp_dtf_units);
        project.expected.embroidery += positiveInt(item.quantity) * positiveInt(props._fp_embroidery_units);
        if (props._fp_dst_setup === 'yes') project.expected.dst = 1;
      }
    });
    return Object.keys(projects).map(function (id) { return projects[id]; });
  }

  function reconciliationPlan(cart, minimum) {
    var projects = cartProjects(cart);
    return {
      orphaned: projects.filter(function (project) {
        return project.quantity === 0 && project.services.length > 0;
      }),
      active: projects.filter(function (project) {
        return project.quantity >= minimum;
      })
    };
  }

  function removeServiceLines(services) {
    if (!services.length) return Promise.resolve();
    var updates = {};
    services.forEach(function (service) { updates[service.key] = 0; });
    return fetch('/cart/update.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({ updates: updates })
    }).then(function (response) {
      return responseJson(response, 'Could not remove the outdated personalisation charge.');
    });
  }

  function changeServiceQuantity(service, quantity) {
    return fetch('/cart/change.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({ id: service.key, quantity: quantity })
    }).then(function (response) {
      return responseJson(response, 'Could not update the personalisation service quantity.');
    });
  }

  function serviceProperties(projectId, key) {
    var def = SERVICE_DEFS[key];
    return {
      'Personalisation': def.label,
      '_fp_project': projectId,
      '_fp_service': def.type,
      '_fp_pricing_model': 'per-placement-v2',
      '_fp_expected_price_pence': String(def.price)
    };
  }

  function addServiceLine(el, projectId, key, quantity) {
    var variantId = serviceVariantId(el, key);
    if (!variantId) return Promise.reject(new Error('Missing the Shopify variant for service: ' + SERVICE_DEFS[key].label + '.'));
    return fetch('/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({ items: [{ id: variantId, quantity: quantity, properties: serviceProperties(projectId, key) }] })
    }).then(function (response) {
      return responseJson(response, 'Could not add the service: ' + SERVICE_DEFS[key].label + '.');
    });
  }

  function syncV2Service(el, project, key) {
    var def = SERVICE_DEFS[key];
    var desiredQty = positiveInt(project.expected[key]);
    var desiredVariant = serviceVariantId(el, key);
    var matching = project.services.filter(function (item) {
      return String((item.properties || {})._fp_service || '') === def.type;
    });
    if (!desiredQty) return removeServiceLines(matching).then(function () { return matching.length > 0; });
    if (!desiredVariant) return Promise.reject(new Error('Missing the Shopify variant for service: ' + def.label + '.'));

    var reusable = matching.filter(function (item) {
      var props = item.properties || {};
      return String(item.variant_id) === String(desiredVariant) &&
        String(props._fp_expected_price_pence || '') === String(def.price);
    })[0];
    var extras = matching.filter(function (item) { return item !== reusable; });

    if (reusable) {
      return removeServiceLines(extras).then(function () {
        if (positiveInt(reusable.quantity) === desiredQty) return extras.length > 0;
        return changeServiceQuantity(reusable, desiredQty).then(function () { return true; });
      });
    }
    return addServiceLine(el, project.id, key, desiredQty)
      .then(function () { return removeServiceLines(matching); })
      .then(function () { return true; });
  }

  function syncV2Project(el, project) {
    var changed = false;
    return ['dtf', 'embroidery', 'dst'].reduce(function (chain, key) {
      return chain.then(function () {
        return syncV2Service(el, project, key).then(function (didChange) { changed = changed || didChange; });
      });
    }, Promise.resolve()).then(function () {
      var known = ['dtf-placement', 'embroidery-placement', 'dst-setup'];
      var obsolete = project.services.filter(function (item) {
        return known.indexOf(String((item.properties || {})._fp_service || '')) === -1;
      });
      return removeServiceLines(obsolete).then(function () { return changed || obsolete.length > 0; });
    });
  }

  function addLegacyServiceLine(project, desiredVariantId, tier) {
    return fetch('/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({ items: [{
        id: desiredVariantId,
        quantity: 1,
        properties: {
          'Personalisation': 'DTF — one logo (' + tier.label + ')',
          '_fp_project': project.id,
          '_fp_service': 'dtf-order-fee',
          '_fp_fee_tier': tier.key,
          '_fp_expected_price_pence': String(tier.amount)
        }
      }] })
    }).then(function (response) { return responseJson(response, 'Could not attach the legacy DTF fee.'); });
  }

  function syncLegacyProject(el, project) {
    var tier = tierForQuantity(project.quantity);
    var desiredVariantId = legacyServiceVariantId(el, tier.key);
    if (!desiredVariantId) return Promise.reject(new Error('Missing the legacy DTF fee variant for tier ' + tier.label + '.'));
    var correct = project.services.filter(function (service) {
      var props = service.properties || {};
      return String(service.variant_id) === String(desiredVariantId) && positiveInt(service.quantity) === 1 &&
        String(props._fp_expected_price_pence || '') === String(tier.amount);
    });
    if (correct.length === 1 && project.services.length === 1) return Promise.resolve(false);
    var keep = correct[0] || null;
    var obsolete = project.services.filter(function (service) { return service !== keep; });
    var add = keep ? Promise.resolve() : addLegacyServiceLine(project, desiredVariantId, tier);
    return add.then(function () { return removeServiceLines(obsolete); }).then(function () { return true; });
  }

  var serviceFeeSyncInFlight = false;
  function feeSyncError(el, message) {
    var box = el.querySelector('[data-fp-fee-sync]');
    var note = el.querySelector('[data-fp-fee-sync-message]');
    if (box) box.hidden = false;
    if (note) note.textContent = message + ' Checkout stays locked. Refresh the page and try again.';
  }

  function reconcileServiceFees() {
    var el = root();
    if (!el || serviceFeeSyncInFlight) return;
    serviceFeeSyncInFlight = true;
    fetch('/cart.js', { headers: { Accept: 'application/json' } })
      .then(function (response) { return responseJson(response, 'Could not read the cart.'); })
      .then(function (cart) {
        var plan = reconciliationPlan(cart, minQty(el));
        var changed = false;
        var removeOrphans = plan.orphaned.reduce(function (chain, project) {
          return chain.then(function () {
            return removeServiceLines(project.services).then(function () { changed = true; });
          });
        }, Promise.resolve());
        return plan.active.reduce(function (chain, project) {
          return chain.then(function () {
            var sync = project.model === 'ordinary-v2'
              ? removeServiceLines(project.services).then(function () { return project.services.length > 0; })
              : project.model === 'per-placement-v2' ? syncV2Project(el, project) : syncLegacyProject(el, project);
            return sync.then(function (didChange) { changed = changed || didChange; });
          });
        }, removeOrphans).then(function () { return changed; });
      })
      .then(function (changed) {
        serviceFeeSyncInFlight = false;
        if (changed) window.location.reload();
      })
      .catch(function (error) {
        serviceFeeSyncInFlight = false;
        feeSyncError(el, error.message || 'Could not update the personalisation charges.');
      });
  }

  function propertiesForRow(base, row, pricing) {
    var props = copyProps(base);
    var dtfPlacements = positiveInt(props._fp_dtf_placements);
    var getsIncludedChest = row.packIncluded && pricing && pricing.freeDtfIndex > -1;
    props._fp_dtf_units = String(Math.max(0, dtfPlacements - (getsIncludedChest ? 1 : 0)));
    props._fp_pack_dtf_entitled = row.packIncluded ? 'yes' : 'no';
    props._fp_pack_dtf_included = getsIncludedChest ? 'yes' : 'no';
    if (row.packGroup) props._fp_pack_group = row.packGroup;
    // Pack identity survives every rewrite of the line (personalise, buy as
    // blank, stale-pending recovery): the group ties the garment back to its
    // pack for the included-chest entitlement, the title keeps the pack name
    // visible on the order.
    if (row.packTitle) props._pack = row.packTitle;
    return props;
  }

  function replacementPlan(rows, baseProperties, serviceItems, pricing) {
    return {
      serviceItems: (serviceItems || []).slice(),
      changes: rows.map(function (row) {
        var change = { id: row.key, quantity: row.removeOnly ? 0 : row.qty };
        if (!row.removeOnly) change.properties = propertiesForRow(baseProperties, row, pricing);
        return change;
      })
    };
  }

  function addServiceItems(items) {
    if (!items.length) return Promise.resolve();
    return fetch('/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({ items: items })
    })
      .then(function (response) { return responseJson(response, 'Could not add the personalisation charge to the cart.'); });
  }

  function changeRowsInPlace(changes) {
    return changes.reduce(function (chain, change) {
      return chain.then(function (cart) {
        // Changing properties can merge two otherwise identical cart lines.
        // If Shopify already merged a later source key, its quantity and new
        // properties are present in the returned cart and no second change is
        // needed for that vanished key.
        if (cart && Array.isArray(cart.items) && !cart.items.some(function (item) { return item.key === change.id; })) {
          return cart;
        }
        return fetch('/cart/change.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
          body: JSON.stringify(change)
        }).then(function (response) {
          return responseJson(response, 'Could not update the garment while applying personalisation.');
        });
      });
    }, Promise.resolve(null));
  }

  function replaceCartLines(rows, baseProperties, serviceItems, pricing) {
    var plan = replacementPlan(rows, baseProperties, serviceItems, pricing);
    // The service-only add cannot exceed a garment's stock limit. Garment
    // lines are then updated in place, so 50 garments never become a
    // temporary request for 100 of the same variant.
    return addServiceItems(plan.serviceItems).then(function () {
      return changeRowsInPlace(plan.changes);
    });
  }

  function applyToRows(el, rows, propsHash, busyBtn, busyLabel, serviceItems, pricing) {
    if (busyBtn) { busyBtn.disabled = true; busyBtn.textContent = 'Saving…'; }
    var errorEl = el.querySelector('[data-fp-cart-error]');
    if (errorEl) errorEl.hidden = true;
    rows.forEach(function (row) {
      if (row.row) row.row.classList.add('is-saving');
      var status = row.row && row.row.querySelector('[data-fp-row-status]');
      if (status) status.textContent = 'Saving…';
    });
    replaceCartLines(rows, propsHash, serviceItems, pricing)
      .then(function () { window.location.reload(); })
      .catch(function (error) {
        rows.forEach(function (row) {
          if (row.row) row.row.classList.remove('is-saving');
          var status = row.row && row.row.querySelector('[data-fp-row-status]');
          if (!status) return;
          status.textContent = row.row.getAttribute('data-fp-kind') === 'blank'
            ? 'Blank — a logo can be added' : 'Awaiting personalisation';
        });
        showError(el, error.message || 'Could not save the personalisation.');
        if (busyBtn) { busyBtn.disabled = false; busyBtn.textContent = busyLabel; }
      });
  }

  // Scopes: 'pending' (default) = eligible lines awaiting personalisation,
  // 'invalid' = lines of a project that dropped below the minimum,
  // 'stale' = legacy lines still flagged `_fp_pending` although their product
  // has no eligibility metafield — they can never be personalised, so the
  // ONLY route to an unlocked checkout is rewriting them as blank here.
  var BLANK_SCOPES = {
    invalid: '[data-fp-invalid-row]',
    stale: '[data-fp-stale-row]'
  };
  function rowFromNode(node) {
    var src = node.querySelector('[data-fp-select-check]') || node;
    return {
      row: node,
      key: src.getAttribute('data-line-key') || node.getAttribute('data-line-key'),
      variantId: src.getAttribute('data-variant-id') || node.getAttribute('data-variant-id'),
      qty: positiveInt(src.getAttribute('data-qty') || node.getAttribute('data-qty')) || 1,
      removeOnly: (src.getAttribute('data-fp-remove-only') || node.getAttribute('data-fp-remove-only')) === 'true',
      packIncluded: (src.getAttribute('data-pack-included') || node.getAttribute('data-pack-included')) === 'true',
      packGroup: src.getAttribute('data-pack-group') || node.getAttribute('data-pack-group') || '',
      packTitle: src.getAttribute('data-pack-title') || node.getAttribute('data-pack-title') || ''
    };
  }
  function rowsFromNodes(nodes) {
    return Array.prototype.slice.call(nodes).map(rowFromNode).filter(function (row) {
      return row.key && row.variantId;
    });
  }
  function blankRows(el, scope) {
    var selector = BLANK_SCOPES[scope] || '[data-fp-select-row][data-fp-kind="pending"]';
    return rowsFromNodes(el.querySelectorAll(selector));
  }
  function projectRows(el, projectId) {
    var nodes = Array.prototype.slice.call(el.querySelectorAll('[data-fp-project-row]')).filter(function (node) {
      return node.getAttribute('data-fp-project-id') === projectId;
    });
    return rowsFromNodes(nodes);
  }

  function makeServiceItems(el, projectId, pricing) {
    var quantities = pricing && pricing.serviceQuantities || {};
    var items = [];
    ['dtf', 'embroidery', 'dst'].forEach(function (key) {
      var quantity = positiveInt(quantities[key]);
      if (!quantity) return;
      var variantId = serviceVariantId(el, key);
      if (!variantId) throw new Error('Missing the Shopify variant for service: ' + SERVICE_DEFS[key].label + '.');
      items.push({ id: variantId, quantity: quantity, properties: serviceProperties(projectId, key) });
    });
    return items;
  }

  function openConfigurator(el) {
    var rows = selectedRows(el);
    if (!rows.length) return;
    var qty = selectedQty(el);
    var min = minQty(el);
    if (qty < min) {
      showError(el, 'Personalisation is available from ' + min + ' garments. You have selected ' + qty + '.');
      return;
    }
    if (!window.FFCPersonalisation) {
      showError(el, 'The personalisation designer did not load correctly. Refresh the page and try again.');
      return;
    }
    var colours = [];
    rows.forEach(function (row) { if (row.colour && colours.indexOf(row.colour) === -1) colours.push(row.colour); });
    var includedDtfQty = rows.reduce(function (sum, row) { return sum + (row.packIncluded ? row.qty : 0); }, 0);
    var allowed = allowedMethodsForRows(rows);
    if (!allowed.dtf && !allowed.embroidery) {
      showError(el, el.getAttribute('data-fp-mixed-method-error'));
      return;
    }

    window.FFCPersonalisation.open({
      qty: qty,
      includedDtfQty: includedDtfQty,
      allowDtf: allowed.dtf,
      methodUnavailable: el.getAttribute('data-fp-method-unavailable'),
      allowEmbroidery: allowed.embroidery,
      colourName: rows[0].colour,
      colourOptions: colours,
      onConfirm: function (propsHash, pricing, structured) {
        if (!rowMethodsMatch(rows, propsHash || {})) {
          showError(el, el.getAttribute('data-fp-method-error'));
          return;
        }
        if (!pricing || !pricing.serviceQuantities) {
          showError(el, 'Could not calculate the personalisation price.');
          return;
        }
        var projectId = newProjectId();
        var withProject = copyProps(propsHash);
        var contractProperties = structuredProperties(structured);
        Object.keys(contractProperties).forEach(function (key) { withProject[key] = contractProperties[key]; });
        withProject._fp_project = projectId;
        // Ordinary personalisation fees are added only by the validated IONOS
        // Draft Order gateway. Technical service variants never enter the
        // public Shopify cart.
        applyToRows(el, rows, withProject, el.querySelector('[data-fp-personalise-selected]'), 'Personalise selected items', [], pricing);
      }
    });
  }

  function bind() {
    var el = root();
    if (!el || el.dataset.fpCartBound === 'true') return;
    el.dataset.fpCartBound = 'true';
    el.addEventListener('change', function (event) {
      var all = event.target.closest('[data-fp-select-all]');
      if (all) {
        checkboxes(el).forEach(function (cb) { cb.checked = all.checked; });
        refresh();
        return;
      }
      if (event.target.closest('[data-fp-select-check]')) refresh();
    });
    el.addEventListener('click', function (event) {
      var removeProjectBtn = event.target.closest('[data-fp-remove-project]');
      if (removeProjectBtn) {
        var projectId = removeProjectBtn.getAttribute('data-fp-remove-project') || '';
        var projectItems = projectRows(el, projectId);
        if (projectItems.length) {
          applyToRows(el, projectItems, BLANK_PROPS, removeProjectBtn, 'Remove personalisation', [], null);
        }
        return;
      }
      var blankBtn = event.target.closest('[data-fp-buy-blank]');
      if (blankBtn) {
        var rows = blankRows(el, blankBtn.getAttribute('data-fp-scope'));
        if (rows.length) applyToRows(el, rows, BLANK_PROPS, blankBtn, 'Buy as blank', [], null);
        return;
      }
      if (event.target.closest('[data-fp-personalise-selected]')) openConfigurator(el);
    });
  }

  function boot() { bind(); refresh(); reconcileServiceFees(); }

  // Read-only bridge for the automated regression suite (scripts/
  // test_personalisation_*.js) — the same pattern as
  // window.FFCPersonalisationPricingV2 / FFCCheckoutGateV2. The storefront
  // flow never calls it; nothing here mutates state.
  window.FFCCartPersonaliseV2 = {
    propertiesForRow: propertiesForRow,
    replacementPlan: replacementPlan,
    rowFromNode: rowFromNode,
    reconciliationPlan: reconciliationPlan,
    tierForQuantity: tierForQuantity,
    blankProps: BLANK_PROPS,
    serviceDefs: SERVICE_DEFS,
    structuredProperties: structuredProperties,
    allowedMethodsForRows: allowedMethodsForRows,
    rowMethodsMatch: rowMethodsMatch
  };

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot);
  else boot();
  document.addEventListener('shopify:section:load', boot);
  document.addEventListener('ffc:cart:rendered', boot);
})();
